






import { defineComponent } from '@vue/composition-api';
import { Icon } from '@iconify/vue2';

export default defineComponent({
    name: 'NotificationRetrievalQueryIcon',
    props: {
        dropdown: {
            type: Boolean,
            default: false,
        },
    },
    components: { Icon },
});
